/**
 * An email address that may break before its "@" when its box is too narrow
 * for it, rather than wherever the box runs out: in the gradebook's Email
 * column, and in the course's staff lists, where an address broke in the
 * middle of its domain (#172).
 */
export function BreakableEmail({ address }: { address: string }) {
  const at = address.indexOf('@');

  if (at <= 0) {
    return <>{address}</>;
  }

  return (
    <>
      {address.slice(0, at)}
      <wbr />
      {address.slice(at)}
    </>
  );
}
